import React from 'react';


const RestrictedBanner = ({onClose}: { onClose: () => void }) => {
  return (
    <div className="fixed top-0 left-0 right-0 bg-red-50 border-b border-red-200 p-4 z-50">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div className="flex gap-3">
          <div className="flex-shrink-0 text-red-500">
            {/* Warning triangle symbol */}
            <span className="text-xl">⚠</span>
          </div>
          <div className="flex-1">
            <p className="text-sm font-medium text-red-800">
              Your account access has been restricted due to a Terms of Service violation.
            </p>
            <p className="mt-1 text-sm text-red-700">
              Please contact{' '}
              <a
                href="mailto:support@neoface.ai"
                className="font-semibold underline hover:text-red-600 transition-colors"
              >
                support@neoface.ai
              </a>{' '}
              for assistance. View our{' '}
              <a
                href="https://neoface.ai/terms"
                target="_blank"
                className="font-semibold underline hover:text-red-600 transition-colors"
              >
                Terms of Service
              </a>{' '}
              for more information.
            </p>
          </div>
        </div>
        <button
          onClick={() => onClose()}
          className="ml-4 p-1.5 text-red-500 hover:bg-red-100 rounded-md transition-colors"
        >
          <span className="text-lg leading-none">&times;</span>
        </button>
      </div>
    </div>
  );
};

export default RestrictedBanner;